import React, { Component } from "react";
import { Link } from "react-router-dom";

import IconButton from "@material-ui/core/IconButton";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

import Moment from 'moment';
import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class MyActivityList extends Component {

	constructor(props) {
		super(props);
		//this.state = { bl: [] };

		//alert(JSON.stringify(props));

		this.state = { totalcount: 0, booklist: [], loading: true };

		//alert(props.fetchurl);

		fetch(props.fetchurl)
			.then(response => response.json())
			.then(data => {
				console.log(JSON.stringify(data));
				//this.setState({ forecasts: data, loading: false });
				//alert(JSON.stringify(data));
				//alert(data.totalcount);
				this.state.totalcount = data.totalcount;
				//this.state.loading = true;
				//alert(this.state.totalcount);

				this.setState({ totalcount: data.totalcount, booklist: data.lstresult, loading: false });
			});
	}

	dorender() {
		let bookDummy = this.state.booklist;

		let struserid = cookie.load("userid");
		let struserdbid = cookie.load("userdbid");

		//alert("1");

		return (
			bookDummy.map((book, index) => {
				//console.log("bookid: " + book.id);
				
				let btnplay = <a className="tag tag-audiobook" href={`mcbab://bookid/${book.refbookid}&${struserdbid}&0`} ><IconButton><PlayArrowIcon /></IconButton></a>
				var mntDate = new Moment(book.regdate);
				var strDisplayDate = mntDate.format('YYYY-MM-DD, h:mm:ss a');

				var strDisplayPlay = "";
				if (book.curduration != 0 && book.totalduration != 0) {

					var hour1 = parseInt(book.curduration / 3600);
					var min1 = parseInt((book.curduration % 3600) / 60);
					var sec1 = parseInt(book.curduration % 60);

					if (hour1 / 10 === 0) { hour1 = "0" + hour1; }
					if (min1 / 10 === 0) { min1 = "0" + min1; }
					if (sec1 / 10 === 0) { sec1 = "0" + sec1; }

					var hour2 = parseInt(book.totalduration / 3600);
					var min2 = parseInt((book.totalduration % 3600) / 60);
					var sec2 = parseInt(book.totalduration % 60);

					if (hour2 / 10 === 0) { hour2 = "0" + hour2; }
					if (min2 / 10 === 0) { min2 = "0" + min2; }
					if (sec2 / 10 === 0) { sec2 = "0" + sec2; }

					strDisplayPlay = '<div className="bookList-lendInfo"><span class="lendInfo-txt">최근듣기: ' + hour1 + ":" + min1 + ":" + sec1 + ' / ' + hour2 + ":" + min2 + ":" + sec2 + '</span>' +
						'</div></div>';
				}

				var st_content = "";
				if (book.serviceType === 50) {
					st_content = <React.Fragment><span className='tag tag-thebook'>더책</span> <span className='tag tag-audiobook'>오디오북</span></React.Fragment>
				}
				else if (book.serviceType === 20) {
					st_content = <span className="tag tag-thebook">더책</span>
				}
				else if (book.serviceType === 40) {
					st_content = <span className="tag tag-audiobook">오디오북</span>
				}

		
				return (
					<React.Fragment>
						<li className="bookList-item">
							<Link to={`/book/${book.refbookid}`}>
								<div className="bookList-thumbnail">
									<div className="thumbnail">
										<img
											className="thumbnail-image"
											src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.refbookid}`}
											alt={book.subject}
										/>
									</div>
								</div>
								<div className="bookList-info">
									<h3 className="bookList-title">{book.subject}</h3>
									<h4 className="bookList-author">작가: {book.authorName}</h4>
									<h4 className="bookList-publisher">출판사: {book.publisherName}</h4>
									<div className="bookList-tag">

										{st_content}

									</div>
									<div className="bookList-lendInfo">
										<span class="lendInfo-txt">일시: {strDisplayDate}</span>
									</div>
									<div className="bookList-lendInfo" dangerouslySetInnerHTML={{ __html: strDisplayPlay }}></div>
									
								</div>
							</Link>
							<div className="bookList-action">
								{btnplay}
							</div>
						</li>
					</React.Fragment>
				);
			})
        );
        this.logPageView();
    }

    logPageView() {
        //ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location);
    }

	render() {

		let contents = this.state.loading === true
			? "Loading..."
			: this.dorender();

		return (
			<React.Fragment>
				<ul className="bookList">
					{contents}
				</ul>
			</React.Fragment>
		);
	}
}

export default MyActivityList;
